export const MAX_IMAGES_PER_PAGE = 5

export const FULL_SIZE = { width: 800, height: 400 }
export const SQUART_SIZE = { width: 400, height: 400 }
